// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import './polyfills';
import "../styles/vendor/bootstrap-datetimepicker.css";
import '../styles/application.scss';

//import 'flipclock/compiled/flipclock.css'; // or dist/flipclock.css depending on what's in node_modules

require('expose-loader?$!expose-loader?jQuery!jquery');
require('expose-loader?toastr!toastr');
//require('script-loader!jquery_ui');

toastr.options.closeButton = true;

require([
  'jquery',
  'vendor/jquery_ujs.js',
  'vendor/jquery_nested_form.js',
  'vendor/chosen.jquery.js',
  'vendor/jquery.minicolors.min.js',
  'vendor/jquery.fileupload.js',
  'icheck',
  'async',
  'vendor/autocomplete_rails.js',
  'vendor/compatibility.js',
  'vendor/pdf-reader/pdf.js',
  'vendor/slick.min.js',
  'vendor/flipclock.min.js',
  'datetimepicker',
  'moment',
  'vendor/circle-progress.js',
  'vendor/jquery.scrollTo.min.js',
  'jquery_cookie',
  'vendor/ckeditor/adapters/jquery.js',
  'vendor/material.min.js',
  'vendor/jquery.slideandswipe.js',
  'mainApp',
  'jspolyfill-array.prototype.find'
], (
  $,
  bootstrap,
  jquery_ujs,
  jquery_nested_form,
  chosen,
  minicolors,
  jqueryFileUpload,
  icheck,
  async,
  autocomplete_rails,
  compatibility,
  pdf,
  slick,
  flipclock,
  datetimepicker,
  moment,
  circle_progress,
  scrollTo,
  jquery_cookie,
  ckeditor_jquery,
  mdl,
  slideAndSwipe,
  mainApp
) => {
  if (window.componentHandler && typeof window.componentHandler.upgradeDom === 'function') {
    window.componentHandler.upgradeDom();
  }
  const app = window.mainApp.getInstance();
});
